import config from "../../../config";

export default function getWebAppApiLoginUrlPrefix() {
  const base = String(config.webAppUrl || "").replace(/\/?$/, "");
  return `${base}/api/login`;
}
